import React, { Component } from 'react'

import TwoUp from '../modules/TwoUp/TwoUp'
import LargeText from '../modules/LargeText/LargeText'
import CaseStudyThumb from '../modules/CaseStudyThumb/CaseStudyThumb'
import Quote from '../modules/Quote/Quote'
import Carousel from '../modules/Carousel/Carousel'
import CampaignSummary from '../modules/CampaignSummary/CampaignSummary'
import InProgress from '../modules/InProgress/InProgress'
import TextBlock from '../modules/TextBlock/TextBlock'
import PizzaAd from '../modules/PizzaAd/PizzaAd'
import FullWidthAsset from '../modules/FullWidthAsset/FullWidthAsset'
import ProcessCards from '../modules/ProcessCards/ProcessCards'
import PotholeMap from '../modules/PotholeMap/PotholeMap'
import Ticker from '../modules/Ticker/Ticker'
import MoreCities from '../modules/MoreCities/MoreCities'
import ItemizedList from '../modules/ItemizedList/ItemizedList'
import CitiesLists from '../modules/CitiesLists/CitiesLists'
import ImageGallery from '../modules/ImageGallery/ImageGallery'


class PageBuilder extends Component {
  constructor (props) {
    super(props)
    this.state = { prettier: true }
  }
  render () {
    const { modules, imageDictionary, videoDictionary } = this.props
    return (
      <div>
        {modules.map((module, index) => {
          switch (module.type) {
            case 'two-up':
              return (
                <TwoUp
                  data={module}
                  imageDictionary={imageDictionary}
                  key={index}
                />
              )
              break
            case 'large-text':
              return <LargeText data={module} key={index} />
              break
            case 'case-study-thumb':
              return (
                <CaseStudyThumb
                  data={module}
                  key={index}
                  imageDictionary={imageDictionary}
                />
              )
              break
            case 'quote':
              return (
                <Quote
                  data={module}
                  imageDictionary={imageDictionary}
                  key={index}
                />
              )
              break
            case 'carousel':
              return (
                <Carousel
                  data={module}
                  key={index}
                  imageDictionary={imageDictionary}
                />
              )
              break
            case 'campaign-summary':
              return (
                <CampaignSummary
                  data={module}
                  key={index}
                  imageDictionary={imageDictionary}
                />
              )
              break
            case 'in-progress':
              return (
                <InProgress
                  data={module}
                  key={index}
                  imageDictionary={imageDictionary}
                />
              )
              break
            case 'textblock':
              return <TextBlock data={module} key={index} />
              break
            case 'pizza-ad':
              return (
                <PizzaAd
                  data={module}
                  imageDictionary={imageDictionary}
                  key={index}
                />
              )
              break
            case 'full-width-asset':
              return (
                <FullWidthAsset
                  data={module}
                  imageDictionary={imageDictionary}
                  key={index}
                  videoDictionary={videoDictionary}
                />
              )
              break
            case 'process-cards':
              return <ProcessCards data={module} key={index} />
              break
            case 'pothole-map':
              return <PotholeMap data={module} key={index} imageDictionary={imageDictionary} />
              break
            case 'ticker':
              return <Ticker data={module} key={index} />
              break
            case 'more-cities':
              return (
                <MoreCities
                  data={module}
                  key={index}
                  imageDictionary={imageDictionary}
                />
              )
              break
            case 'itemized-list':
              return <ItemizedList data={module} key={index} />
              break
            case 'cities-lists':
              return <CitiesLists data={module} key={index} />
              break
            case 'image-gallery':
              return (
                <ImageGallery
                  data={module}
                  key={index}
                  imageDictionary={imageDictionary}
                />
              )
              break
          }
        })}
      </div>
    )
  }
}

export default PageBuilder



// WEBPACK FOOTER //
// ./src/components/pagebuilder/pagebuilder.js